module.exports = __webpack_public_path__ + "static/mobile-home-f46ee697d328f7424212c2db2cf7a3b8.png";